import * as SwitchPrimitives from '@radix-ui/react-switch'
import * as React from 'react'
import { css, styled } from 'styled-components'
import { tk } from '../../utils'

const Wrapper = styled(SwitchPrimitives.Root)<{ disabled?: boolean }>`
  width: 44px;
  height: 24px;
  background-color: ${tk('color_semantic_bg_input_strong')};
  border-radius: ${tk('radius_rounded')};
  padding: 2px;

  &[data-state='checked'] {
    background-color: ${tk('color_semantic_bg_success')};
  }

  &:hover {
    background-color: ${tk('color_semantic_bg_input_strong_hover')};
  }

  &[data-state='checked']:hover {
    background-color: ${tk('color_semantic_bg_success_hover')};
  }

  &:focus {
    box-shadow: ${tk('shadow_focus_grey')};
  }

  ${({ disabled }) => disabled && modDisabled()}
`

const Thumb = styled(SwitchPrimitives.Thumb)`
  width: 20px;
  height: 20px;
  border-radius: ${tk('radius_rounded')};
  background: ${tk('color_semantic_bg')};
  display: block;
  transition: transform 300ms;

  &[data-state='checked'] {
    transform: translateX(100%);
  }
`

function modDisabled() {
  return css`
  background: ${tk('color_semantic_bg_input_strong_disabled')};
  pointer-events: none;
  &[data-state='checked'] {
    background-color: ${tk('color_semantic_bg_success_disabled')};
  }
`
}

function Switch({ ref, ...props }: React.ComponentPropsWithRef<typeof SwitchPrimitives.Root>) {
  return (
    <Wrapper {...props} ref={ref}>
      <Thumb />
    </Wrapper>
  )
}

Switch.displayName = SwitchPrimitives.Root.displayName

/**
 * @deprecated Use `Switch` from `@sunwebgroup/ui-components/uds` instead.
 */

export default styled(Switch)``
